import { ReactElement, ReactNode } from 'react';
import { makeStyles } from 'tss-react/mui';

import { WalletsDialog } from 'modules/auth';
import {
  NavigationDialog,
  SuccessStakeDialog,
  SuccessUnstakeDialog,
} from 'modules/dialogs';
import { BoostDialog } from 'modules/rewards';

import { Footer } from '../Footer';
import { Header } from '../Header';
import bg from './assets/background.png';

interface ILayoutProps {
  children: ReactElement | ReactNode;
}

export function Layout({ children }: ILayoutProps): ReactElement {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <Header />

      <div className={classes.content}>
        {children}

        <Footer />
      </div>

      <WalletsDialog />

      <SuccessStakeDialog />

      <SuccessUnstakeDialog />

      <BoostDialog />

      <NavigationDialog />
    </div>
  );
}

const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundImage: `url('${bg}')`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
  },
  content: {
    maxWidth: 1160,
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    flex: 1,
    flexDirection: 'column',
    margin: '0 auto',
    padding: theme.spacing(12, 10, 6),

    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(6, 4),
    },
  },
}));
